<template>
  <div class="form-wrapper">
    <form @submit.prevent="save()">
      <b-form-group label="Nom" label-for="formatName">
        <b-input
            autofocus
            required
            v-model="format.name"
            id="formatName"
            class="mt-2"
        />
      </b-form-group>
      <div class="d-flex justify-content-center align-items-center">
        <b-btn
            type="submit"
            :variant="load ? 'link' : 'secondary'"
            size="lg"
            :disabled="load"
        >
          <span v-if="!load">Enregistrer</span>
          <span v-else><b-spinner small/></span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import {http} from '@/http';

/**
* @vuese
* Formulaire pour les formats de fiche
* @group COMPONENTS_ADMIN
*/
export default {
  name: 'FormAdminFormat',
  props: {
    // Nom du format
    format: {
      type: Object,
      default() {
        return {
          name: ''
        };
      }
    }
  },
  data() {
    return {
      load: false,
      form: {
        name: ''
      }
    };
  },
  methods: {
    /**
     * @vuese
     * Création d'un nouveau format d'étape
     * @returns {Promise<AxiosResponse<any>>}
     */
    save() {
      let dataSend = JSON.parse(JSON.stringify(this.format));

      this.load = true;

      let url = '/api/card_formats';
      let method = 'post';
      let mode = 'new';
      if (dataSend['@id']) {
        url = dataSend['@id'];
        method = 'put';
        mode = 'update';
      }

      return http[method](url, dataSend).then((res) => {
        // Sauvegarde du format
        this.$emit('saved', res.data);
        this.$emit(mode, res.data);
        // Création ou mise à jour
        this.load = false;
        return res;
      });
    }
  }
};
</script>